import { Box, Grid, Stack, Typography } from '@atgfr8/atg-ui-tailwind';
import { useNavigate } from '@solidjs/router';
import { AlertIcon } from '@atgfr8/icons';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { routeClaimDetails } from '@utils/routeClaimDetails';
import { formatAmount } from '@utils/utils';
import { Component } from 'solid-js';

import classes from './classes';

export type ClaimProps = {
  load: ILoadEditViewModel;
};

const Claim: Component<ClaimProps> = (props: ClaimProps) => {
  const navigate = useNavigate();
  return (
    <Stack
      class={classes.mainContainer}
      mb={2}
      onClick={() => {
        const claimData = props.load.claim;
        if (claimData) {
          const isNative = routeClaimDetails(claimData.loadId);
          isNative && navigate(`/claim/${claimData.loadId}`);
        }
      }}
    >
      <Box class={classes.topContainer}>
        <Box class="px-[16px]">
          <AlertIcon class={classes.warninIcon} size={36} />
        </Box>
        <Stack spacing={1} pr={2}>
          <Typography
            component="div"
            variant="body1"
            class={classes.topContainerTitle}
          >
            Claim
          </Typography>
          <Typography
            component="div"
            variant="body1"
            class={classes.topContainerSubtitle}
            sxProps={{
              wordBreak: 'break-word',
            }}
          >
            {props.load.claim?.description}
          </Typography>
        </Stack>
      </Box>
      <Grid size={12} container>
        <Grid size={2} class="px-3 py-2">
          <Stack spacing={1}>
            <Typography
              component="div"
              variant="body1"
              class={classes.bottomContainerTitle}
            >
              Claim Number
            </Typography>
            <Typography component="div" variant="body1">
              {props.load.claim?.claimNumber}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={2} class="px-3 py-2">
          <Stack spacing={1}>
            <Typography
              component="div"
              variant="body1"
              class={classes.bottomContainerTitle}
            >
              Status
            </Typography>
            <Typography component="div" variant="body1">
              {props.load.claim?.status}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={2} class="px-3 py-2">
          <Stack spacing={1}>
            <Typography
              component="div"
              variant="body1"
              class={classes.bottomContainerTitle}
            >
              Claim Filed Amount
            </Typography>
            <Typography component="div" variant="body1">
              {formatAmount(props.load.claim?.claimValue ?? undefined)}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={2} class="px-3 py-2">
          <Stack spacing={1}>
            <Typography
              component="div"
              variant="body1"
              class={classes.bottomContainerTitle}
            >
              Claim File Date
            </Typography>
            <Typography component="div" variant="body1">
              {props.load.claim?.claimDateFormatted}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={2} class="px-3 py-2">
          <Stack spacing={1}>
            <Typography
              component="div"
              variant="body1"
              class={classes.bottomContainerTitle}
            >
              Occured Date
            </Typography>
            <Typography component="div" variant="body1">
              {props.load.claim?.occurredDateFormatted}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={2} class="px-3 py-2">
          <Stack spacing={1}>
            <Typography
              component="div"
              variant="body1"
              class={classes.bottomContainerTitle}
            >
              Closed Date
            </Typography>
            <Typography component="div" variant="body1">
              {props.load.claim?.closedFormattedDate}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Claim;
